import comp from "./Transition";
export default comp;
